import jsCookie from 'js-cookie'

const queryParameterName = 'lastAmpAuthState'

// Returns the new url with our new query parameter.
function updateQueryStringParameter(
  uri: string | undefined,
  key: string,
  value: string
): string | undefined {
  if (!uri) return

  // Keeping original escaped entities exactly as they appeared
  const re = new RegExp('([?&amp;])' + key + '=.*?(&amp;|$)', 'i')
  const separator = uri && uri.indexOf('?') && uri.indexOf('?') !== -1 ? '&amp;' : '?'

  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2')
  }

  return uri + separator + key + '=' + value
}

// Gets the value for lastAmpAuthState from the cookie.
export const getLastAmpAuthState = (): string => {
  if (window.location.hostname === 'localhost') {
    jsCookie.set('lastAmpAuthState', 'unrecognized')
  }

  const lastAmpAuthState = jsCookie.get('lastAmpAuthState')
  return lastAmpAuthState || 'unrecognized'
}

export const getAdvisorLinkWithCookie = (url: string): string | undefined => {
  const authState = getLastAmpAuthState()
  const update = updateQueryStringParameter(url, queryParameterName, authState)
  return update
}
